<template>
  <v-hover v-slot="{ hover }">
    <LazyHydrate when-visible>
    <nuxt-link class="d-block" :to="`/articles/${data.slug}`">
      <client-only>
        <edit-asset-button
          :link="`/articles/edit/${data.slug}`"
        ></edit-asset-button>
      </client-only>

      <v-card :elevation="hover ? 5 : 0" class="transition-animations" tile>
        <v-layout class="flex-wrap flex-md-nowrap align-center">
          <v-img
            class="mx-auto"
            :src="data.cover_image"
            min-width="200px"
            max-width="200px"
            height="100%"
            aspect-ratio="1.5"
            :alt="data.title"
          >
          </v-img>
          <v-layout column justify-space-between>
            <v-card-text class="py-1">
              <h2
                class="mb-2 title"
                :class="hover ? 'article-title-hover' : ''"
              >
                {{ data.title }}
              </h2>
              <span
                v-if="data.display_date"
                class="
                  text--secondary
                  font-weight-normal
                  caption
                  text-capitalize
                "
              >
                {{ data.display_date | formatDate }}
              </span>
            </v-card-text>
            <v-card-text class="py-0">
              <div v-text="data.short_description"></div>
            </v-card-text>
            <v-card-text class="pt-0 pb-1">
              <template v-for="(tag, index) in data.tags_array">
                <v-chip
                  v-if="index < 4"
                  :key="index"
                  x-small
                  class="ma-1 ml-0"
                  dark
                  color="black"
                  label
                >
                  {{ tag }}
                </v-chip>
              </template>
            </v-card-text>
          </v-layout>
        </v-layout>
      </v-card>
    </nuxt-link>
    </LazyHydrate>

  </v-hover>

</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'
import EditAssetButton from '~/components/common/EditAssetButton'

export default {
  name: 'ArticleCard',
  components: { EditAssetButton, LazyHydrate },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.article-title-hover {
  color: var(--v-primary-base);
  transition: all 0.2s ease-in-out;
}
</style>
